// ESM wrapper — imports from the pre-bundled generator (built by generator/bundle.mjs)
// Run `node generator/bundle.mjs` after updating generator source files.
// Generator v3.18.1

// Synchronous wrapper — engine is loaded on first call
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let _cached: any = null

// Pre-load eagerly
// @ts-ignore — engine.js is auto-generated, no .d.ts
const _loadPromise = import('./engine.js').then(mod => {
  _cached = mod.default ?? mod
})

import type { GeneratorResult, GeneratorParams } from './types'

export function generateNPC(params: GeneratorParams): GeneratorResult {
  if (!_cached) throw new Error('Generator not loaded yet — try again in a moment')
  return _cached.generateNPC(params) as GeneratorResult
}

export function generateFullNPC(params: GeneratorParams): GeneratorResult {
  if (!_cached) throw new Error('Generator not loaded yet')
  return _cached.generateFullNPC(params) as GeneratorResult
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function enrichResult(result: GeneratorResult, opts?: any): GeneratorResult {
  if (!_cached) throw new Error('Generator not loaded yet')
  return _cached.enrichResult(result, opts) as GeneratorResult
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function generateFullNPCFromDescription(constraints: any, opts?: any): Promise<GeneratorResult> {
  if (!_cached) throw new Error('Generator not loaded yet')
  return _cached.generateFullNPCFromDescription(constraints, opts) as GeneratorResult
}

export function isReady(): boolean {
  return _cached !== null
}

export { _loadPromise as ready }

// Re-export types
export type {
  GeneratorResult,
  GeneratorParams,
  AgingResult,
  SkillRosterEntry,
  FamilyMember,
  Contact,
  HistoryEntry,
  PhysicalProfile,
  OceanScores,
  Archetype,
  OccupationWeapon,
  AutomaticSkill,
  AppearanceDescriptions,
} from './types'
